import DefaultNotification from "./DefaultNotification";

class SuccessNotification extends DefaultNotification {
    type = "success";
}

export default SuccessNotification;